"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.formatLeaderboardPosition = formatLeaderboardPosition;
exports.normalizeUserData = normalizeUserData;

var _translations = require("../../libs/translationsUtils/translations");

function normalizeUserData(id, name, avatar, rank) {
  var isLoggedInUser = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
  var isLoggedInUserSection = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : false;
  var rankTitle = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : 'rank';
  var username = name;

  if (isLoggedInUser) {
    username = name.concat(' (', (0, _translations.t)('Forum', 'leaderboard.logged.in.user'), ')');
  }

  if (isLoggedInUserSection) {
    username = (0, _translations.t)('Forum', 'leaderboard.logged.in.user');
  }

  return {
    id: id,
    name: username,
    avatar: avatar,
    rank: {
      avatarIconUrl: rank,
      name: rankTitle
    }
  };
}

function formatLeaderboardPosition(leaderboardPosition, points) {
  if (points === 0 || leaderboardPosition === null) {
    return '-';
  }

  if (leaderboardPosition > 1000) {
    return '>1000';
  }

  return "".concat(leaderboardPosition);
}